module.exports = __webpack_public_path__ + "static/media/bateau_poisson_claire.51ab9ce6.png";